import { API } from '@/api';

export const classes = {
  wrapper: 'flex flex-col',
  email: 'mb-[26px]',
  password: 'mb-[52px]',
  forgotWrapper: 'mt-[22px] flex justify-center',
};

export async function loginUser(email: string, password: string) {
  await API.Users.login(email.trim(), password.trim());
  return API.Users.fetchCurrentUser();
}
